import { render, staticRenderFns } from "./AnnualStatistics.vue?vue&type=template&id=5267a8a6&"
import script from "./AnnualStatistics.vue?vue&type=script&lang=js&"
export * from "./AnnualStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports